var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _g3, _path8, _path9, _path10, _path11, _g4, _ellipse, _ellipse2, _rect, _path12, _path13, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 137,
    viewBox: "0 0 73 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8799 115.408C24.0349 111.903 31.5433 107.825 35.7143 106.271L42.2297 117.795L59.6445 121.636C57.4755 121.636 39.0086 130.232 31.0138 134.44V121.504C27.0409 118.648 22.8799 115.408 22.8799 115.408Z",
    fill: "#531CB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9073 112.674L59.6473 121.636L42.2324 117.795L51.9073 112.674Z",
    fill: "#7266F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6519 0L93.3194 24.007H51.9844L72.6519 0Z",
    fill: "url(#paint0_linear_1565_29680)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6538 137L51.9863 112.993L93.3213 112.993L72.6538 137Z",
    fill: "url(#paint1_linear_1565_29680)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1565_29680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.6524 6.40161L75.0469 13.6278L82.3274 16.0044L75.0469 18.381L72.6524 25.6072L70.258 18.381L62.9775 16.0044L70.258 13.6278L72.6524 6.40161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6524 6.61899L74.982 13.6493L74.9928 13.6821L75.0256 13.6928L82.107 16.0044L75.0256 18.316L74.9928 18.3267L74.982 18.3595L72.6524 25.3898L70.3229 18.3595L70.3121 18.3267L70.2792 18.316L63.1979 16.0044L70.2792 13.6928L70.3121 13.6821L70.3229 13.6493L72.6524 6.61899Z",
    stroke: "#FAFF00",
    strokeWidth: 0.136746
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8836 34.249L44.1641 28.4874L23.4966 64.0177L12.8836 34.249Z",
    fill: "url(#paint2_linear_1565_29680)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.886 102.749L23.499 72.9802L44.1665 108.51L12.886 102.749Z",
    fill: "url(#paint3_linear_1565_29680)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.847 67.8609C125.847 96.662 102.323 120.014 73.2997 120.014C44.276 120.014 20.752 96.662 20.752 67.8609C20.752 39.0598 44.276 15.7076 73.2997 15.7076C102.323 15.7076 125.847 39.0598 125.847 67.8609Z",
    fill: "url(#paint4_linear_1565_29680)",
    stroke: "url(#paint5_linear_1565_29680)",
    strokeWidth: 0.683732
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1565_29680)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.298,
    cy: 67.8614,
    rx: 46.4396,
    ry: 46.0933,
    fill: "url(#paint6_linear_1565_29680)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_1565_29680)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.2963,
    cy: 67.8589,
    rx: 38.6996,
    ry: 38.4111,
    fill: "url(#paint7_linear_1565_29680)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1565_29680)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4449 61.3057C49.7556 59.4538 51.8263 57.7938 53.4839 58.8695L84.4372 78.9574C86.1506 80.0693 85.3632 82.7292 83.3206 82.7292H59.8448C58.988 82.7292 58.2214 82.1966 57.9225 81.3936L50.4449 61.3057Z",
    fill: "url(#paint8_linear_1565_29680)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1392 61.2809C96.8357 59.4334 94.7757 57.765 93.1133 58.8302L61.7119 78.9509C59.9868 80.0562 60.7697 82.7292 62.8185 82.7292H86.6341C87.4878 82.7292 88.2523 82.2004 88.5534 81.4016L96.1392 61.2809Z",
    fill: "url(#paint9_linear_1565_29680)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4577 53.9185C72.2079 52.3859 74.3923 52.3859 75.1424 53.9185L87.9305 80.045C88.5975 81.4078 87.6054 82.998 86.0881 82.998H60.512C58.9947 82.998 58.0026 81.4078 58.6696 80.045L71.4577 53.9185Z",
    fill: "url(#paint10_linear_1565_29680)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1565_29680",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 52,
    width: 31,
    height: 31
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4606 53.9144C72.2108 52.3818 74.3952 52.3818 75.1453 53.9144L87.9334 80.0409C88.6004 81.4036 87.6083 82.9938 86.0911 82.9938H60.5149C58.9976 82.9938 58.0055 81.4036 58.6726 80.0409L71.4606 53.9144Z",
    fill: "url(#paint11_linear_1565_29680)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1565_29680)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1565_29680)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8373,
    cy: 4.56941,
    rx: 16.8373,
    ry: 4.56941,
    transform: "matrix(0.204188 0.978932 -0.979534 0.201279 83.7305 54.2727)",
    fill: "#FFF5D2",
    fillOpacity: 0.8
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.302,
    cy: 47.7497,
    rx: 2.95928,
    ry: 2.93722,
    fill: "url(#paint12_linear_1565_29680)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.9173,
    cy: 56.2928,
    rx: 2.42123,
    ry: 2.40318,
    fill: "url(#paint13_linear_1565_29680)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.3008,
    y: 85.314,
    width: 29.4328,
    height: 3.98365,
    rx: 1.99182,
    fill: "url(#paint14_linear_1565_29680)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6571 34.5708L53.6148 37.4613L56.527 38.4119L53.6148 39.3625L52.6571 42.253L51.6993 39.3625L48.7871 38.4119L51.6993 37.4613L52.6571 34.5708Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0475 21.7681L43.2823 28.5125L50.0774 30.7307L43.2823 32.9488L41.0475 39.6933L38.8127 32.9488L32.0176 30.7307L38.8127 28.5125L41.0475 21.7681Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1565_29680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9131 101.442L42.233 117.794C69.9677 103.07 96.4125 113.953 104.152 117.794L114.472 101.442C111.521 98.0582 99.1546 91.2164 73.2956 90.9156C47.4367 90.6149 34.9327 97.8076 31.9131 101.442Z",
    fill: "url(#paint15_linear_1565_29680)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1565_29680",
    x: 60.9263,
    y: 4.35042,
    width: 23.452,
    height: 23.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0256,
    result: "effect1_foregroundBlur_1565_29680"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1565_29680",
    x: 26.8584,
    y: 20.4006,
    width: 92.8789,
    height: 93.5542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.36746
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683732
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.616667 0 0 0 0 0.407 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_29680"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_1565_29680",
    x: 34.5967,
    y: 28.0803,
    width: 77.3994,
    height: 79.5572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36746
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7 0 0 0 0 0.465967 0 0 0 0 0.0116667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_29680"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.36746
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683732
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.72 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1565_29680",
    result: "effect2_innerShadow_1565_29680"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1565_29680",
    x: 46.1286,
    y: 44.8125,
    width: 54.2222,
    height: 47.22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36746
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683732
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.358333 0 0 0 0 0.1935 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_29680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_29680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1565_29680",
    x: 72.9464,
    y: 51.0639,
    width: 19.4929,
    height: 41.2221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.0512,
    result: "effect1_foregroundBlur_1565_29680"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1565_29680",
    x: 18.2384,
    y: 84.0692,
    width: 109.909,
    height: 54.237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.83732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.83732
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_29680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_29680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1565_29680",
    x1: 64.0606,
    y1: 9.60278,
    x2: 81.2432,
    y2: 9.60278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1565_29680",
    x1: 81.2451,
    y1: 127.397,
    x2: 64.0625,
    y2: 127.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1565_29680",
    x1: 16.9666,
    y1: 46.4353,
    x2: 25.4619,
    y2: 31.6105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1565_29680",
    x1: 25.5604,
    y1: 105.332,
    x2: 17.0651,
    y2: 90.5075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1565_29680",
    x1: 39.3961,
    y1: 28.826,
    x2: 109.331,
    y2: 107.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237301,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1565_29680",
    x1: 73.2997,
    y1: 15.3657,
    x2: 73.2997,
    y2: 120.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1565_29680",
    x1: 43.6282,
    y1: 32.6512,
    x2: 102.442,
    y2: 104.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D58500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1565_29680",
    x1: 47.6863,
    y1: 36.2262,
    x2: 79.1623,
    y2: 106.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#B45F1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1565_29680",
    x1: 50.8266,
    y1: 63.2367,
    x2: 66.452,
    y2: 74.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1565_29680",
    x1: 94.1408,
    y1: 59.9298,
    x2: 84.7298,
    y2: 76.9967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1565_29680",
    x1: 65.0761,
    y1: 67.0613,
    x2: 81.759,
    y2: 67.0613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FCE77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FFCC1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1565_29680",
    x1: 65.079,
    y1: 67.0571,
    x2: 81.762,
    y2: 67.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FCE77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FFCC1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1565_29680",
    x1: 73.3021,
    y1: 44.8125,
    x2: 73.3021,
    y2: 50.6869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1565_29680",
    x1: 49.9173,
    y1: 53.8896,
    x2: 49.9173,
    y2: 58.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1565_29680",
    x1: 58.6352,
    y1: 87.3058,
    x2: 88.0681,
    y2: 87.3058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE07C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1565_29680",
    x1: 36.3305,
    y1: 106.451,
    x2: 110.663,
    y2: 105.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523AE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.b588b0aef9710ac71ad1187e46e3ac81.svg";
export { ForwardRef as ReactComponent };